<template>
    <div>
        <div class="kcf-expand">
            <div class="d-flex justify-content-right align-items-right flex-column">
                <div class="kc-form-expansion-title">
                    <slot name="label" />
                </div>

                <BFormRadioGroup
                    v-model="selected"
                    class="kc-form-expansion-radio"
                    data-cy="kcFormExpandRadioGroup"
                    :options="options"
                    stacked
                    @change="toggleFormExpansion($event)"
                />
            </div>
            <div
                :class="['kc-form-collapse-content', {'kc-form-expanded': expanded}]"
            >
                <BCollapse
                    v-model="expanded"
                    class="kc-form-expansion-collapse"
                    data-cy="formExpandCollapse"
                >
                    <slot name="content" />
                </BCollapse>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * @group Sections
     * A component to utilize Kit Car KCFormExpansion component.
     */
    export default {
        name: 'KCFormExpansion',
        data() {
            return {
                expanded: false,
                options: [
                    {'text': 'Yes', value: true},
                    {'text': 'No', value: false},
                ],
                selected: null
            };
        },
        methods: {
            toggleFormExpansion($event) {
                this.expanded = $event;
                this.$emit('toggle', this.expanded);
            },
        }
    };
</script>
